module.exports = __webpack_public_path__ + "static/logo-9770ecef8f35fbb03227d2f9426d96d2.svg";